import { render, staticRenderFns } from "./MotivoAtendimento.vue?vue&type=template&id=6d61141d"
import script from "./MotivoAtendimento.vue?vue&type=script&lang=js"
export * from "./MotivoAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports